<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <div class="column is-8">
          <h4 class="is-size-4-desktop">Sucursales</h4>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="sucursales"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
          >
            <b-table-column v-slot="props" field="id" label="Código" width="5%">
              <span class="has-text-centered">
                {{ props.row.id }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="nombre"
              label="Nombre Sucursal"
            >
              <span class="has-text-centered">
                {{ props.row.nombre }}
              </span>
            </b-table-column>
            <b-table-column v-slot="props" label="Acciones" width="7%">
              <b-button
                type="is-info"
                size="is-small"
                @click="modificarRegistro(props.row.id)"
              >
                <b-icon icon="pencil-alt" />
              </b-button>
              &nbsp;
              <b-button
                type="is-danger"
                size="is-small"
                @click="confirmarEliminarRegistro(props.row.id)"
              >
                <b-icon icon="trash-alt" />
              </b-button>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button
            type="is-info"
            icon-left="plus"
            :disabled="!puedeAgregar"
            @click="agregarRegistro"
          >
            Agregar
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <sucursal-form
        :titulo="tituloForm"
        :modificacion="modificacion"
        :objeto="objeto"
        @close="cerrarModalHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import SucursalForm from '@/components/mantenedor/sucursales/SucursalForm.vue'
import { sucursalService } from '@/services'

export default {
  name: 'Sucursales',
  components: {
    SucursalForm
  },
  data() {
    return {
      sucursales: [],
      estaModalAbierto: false,
      paginaActual: 1,
      tamanoPagina: 10,
      tituloForm: null,
      objeto: null,
      modificacion: false
    }
  },
  computed: {
    puedeAgregar() {
      return true
    }
  },
  mounted() {
    this.getSucursales()
  },
  beforeDestroy() {},
  methods: {
    agregarRegistro() {
      this.tituloForm = 'Agregar Sucursal'
      this.estaModalAbierto = true
    },
    modificarRegistro(id) {
      this.tituloForm = 'Modificar Sucursal'
      this.objeto = this.sucursales.filter((item) => item.id === id)[0]
      this.modificacion = true
      this.estaModalAbierto = true
    },
    confirmarEliminarRegistro(id) {
      const objeto = this.sucursales.filter((item) => item.id === id)[0]
      this.$buefy.dialog.confirm({
        title: 'Quitar sucursal',
        message: `¿Est&aacute; seguro de <b>quitar</b> la sucursal <b>${objeto.nombre}</b>?`,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.eliminarRegistro(id)
      })
    },
    eliminarRegistro(id) {
      sucursalService
        .deleteSucursal(id)
        .then(() => {
          this.notificarAccionCompletada('Se eliminó sucursal correctamente')
          this.getSucursales()
        })
        .catch((error) => this.procesarError(error))
    },
    cerrarModalHandle(payload = false) {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.objeto = null
      this.modificacion = false
      if (payload) {
        this.getSucursales()
      }
    },
    getSucursales() {
      const self = this
      return sucursalService
        .getSucursales()
        .then((response) => (self.sucursales = response.data))
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>
